import { clsx } from 'clsx'
import { Carousel } from 'component/Carousel/Carousel'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Card2 } from 'page/InferenceScreen/Carousel/Card2'
import { useEffect } from 'react'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './Carousel2.module.scss'

export const Carousel2 = observer(() => {
  const { carousel } = store.carousel
  const { item } = carousel
  const complete = item?.complete
  const className = clsx(css.carousel, opt.stand2 && css.stand)

  useEffect(() => {
    if (complete) void controller.viewInference(item)
  }, [complete, item])

  const onClick = useLatestCallback((active: boolean) => {
    if (active) controller.openFullscreen()
  })

  const render = useLatestCallback((item: InferenceStore) => {
    return <Card2 carousel={carousel} inference={item} onClick={onClick} />
  })

  return <Space className={className} center>
    <Carousel store={carousel} render={render} />
  </Space>
})
